module.exports = __webpack_public_path__ + "static/media/entertainment.ef7a8855.png";